import { CKDrawer } from 'clearkit';

import { ExportProspectList } from '../Exports/ExportProspectList';
import { ExportProspectSalesforce } from '../Exports/ExportProspectSalesforce';
import { useProspector } from '../useProspector';
import { isExporting, isExportingSalesforce } from '../util';

export function ExportProspectsDrawer() {
  const [state, send] = useProspector();

  const isOpen = isExporting(state);

  const handleClose = () => send('CANCEL');

  const isSalesforce = isExportingSalesforce(state);

  return (
    <CKDrawer isVisible={isOpen} onToggle={handleClose} size="xxl">
      {isSalesforce ? <ExportProspectSalesforce /> : <ExportProspectList />}
    </CKDrawer>
  );
}
